import { ICheckoutContextConfig } from './contextCheckoutConfig.d';

export const contextCheckoutConfig: ICheckoutContextConfig = {
  ui: {
    intlTelInput: {
      isEnabled:  false,
    },
    informationBox: {
      enabled: false,
      text: '',
    },
    initialMobileVisibleItems: {
      onSmallMobile: 1,
      onMediumMobile: 2,
    },
    ingridFieldsInformationText: {
      enabled: false,
      text: '',
    },
    productItem: {
      isSkuVisible: true,
      isSizeVisible: true,
      isVariantNameVisible: true,
      withProductDetails: false,
      productUrlPrefix: '',
    },
    cartFooterNote: {
      enabled: false,
      html: '',
    },
    cartPaymentLogoBar: {
      enabled: true,
    },
    personalInformation: {
      isRememberMeVisible: true,
    },
    additionalNotes: {
      enabled: true,
    },
    orderSummary: {
      isVoucherVisible: true,
      isNewsletterVisible: false,
    },
    consentGroup: {
      termsLink: {
        isTermsLinkVisible: true,
        url: '',
      },
      newsletterTermsLink: {
        isTermsLinkVisible: true,
        url: '',
      }
    },
    steps: {
      isIngridFieldsVisible: false,
    },
    voucher: {
      type: 'toggle',
    },
    layout: {
      type: 'flat',
    },
    shippingMethodDescriptions: {
      enabled: false,
      descriptions: {
        'shipping_method_uri': '',
      },
    },
    paymentMethodDescriptions: {
      enabled: false,
      descriptions: {
        'payment_method_uri': '',
      },
    },
    countryDescriptions: {
      enabled: false,
      descriptions: {
        'country_code': '',
      },
    },
    giftWrap: {
      isEnabled: false,
      productId: '', // This is hardcoded TODO: fix if Centra implement gift wrap functionality
    },
    splitShippingCountry: {
      isEnabled: true, // Show country/state select on the top, outside of shipping address form
    },
  },
  modules: {
    wallet: {
      isEnabled: false,
      method: 'klarna-checkout',
    },
    membership: {
      isEnabled: false,
      enabledTabs: [
        'personal',
        'password',
        'checks',
        'orders',
      ],
      customerClubFields: {
        isEnabled: false,
        physicalStores: [
          { store: 'SE007', name: 'Boutique Bromma' },
          { store: 'SE006', name: 'Boutique Nova' },
          { store: 'BUTIK001', name: 'Boutique Stockholm' },
          { store: 'SE010', name: 'Boutique Mall of Scandinavia' }
        ],
      },
    },
  },
  dataDictionary: {
    cities: [
      { city: 'Stockholm', name: 'Stockholm' },
    ],
  },
};

export const layoutTypes = {
  steps: 'steps',
  flat: 'flat'
};

export const voucherTypes = {
  link: 'link',
  toggle: 'toggle'
};

export const walletMethods = {
  klarnaCheckout: 'klarna-checkout',
  applePay: 'apple-pay'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/config/contextCheckoutConfig.ts